import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth';
import { IAppRoles } from './auth/auth.service';

const DEFAULT_ROUTES: { [key in IAppRoles]: string } = {
  '300000001': 'home-large-accounts',
  '300000002': 'home-large-accounts',
  '300000003': 'home-pymes',
  '300000004': 'home-pymes',
  '300000005': 'home-pymes',
  '300000006': 'home-pymes',
  '300000007': 'home-pymes'
};

@Injectable({
  providedIn: 'root'
})
export class RouteRedirectGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      this.auth.ready.subscribe(r => {
        if (r) {
          const allowed = next.data.roles;
          if (allowed.indexOf(this.auth.getRole().code) === -1) {
            return this.router.navigate([DEFAULT_ROUTES[this.auth.getRole().code]]).then(() => resolve(false));
          } else {
            resolve(true);
          }
        }
      });
    });
  }
}
